@if (currentTimezone$ | async; as currentTimezone) {
  @if (currentTimezone.localTechieOffset !== currentTimezone.meetTechieOffset) {
    <div class="pb-3">
      <ng-container i18n="Label before the timezone select@@timezoneToggle.timeLabel">Time</ng-container>:&nbsp;
      <div class="btn-group btn-group-sm" role="group">
        <input type="radio" class="btn-check" [checked]="currentTimezone.activeTimezoneLabel === 'local'" />
        <label class="btn btn-outline-primary" (click)="setCurrentTimezone('local')"
          ><ng-container i18n="My timezone label@@timezoneToggle.you">You</ng-container>&nbsp;({{
            currentTimezone.localShortTimezone
          }})</label
        >
        <input type="radio" class="btn-check" [checked]="currentTimezone.activeTimezoneLabel === 'meet'" />
        <label class="btn btn-outline-primary" (click)="setCurrentTimezone('meet')"
          ><ng-container i18n="Meet timezone label@@timezoneToggle.meet">Meet</ng-container>&nbsp;({{
            currentTimezone.meetShortTimezone
          }})</label
        >
      </div>
    </div>
  }
}
